import { Palmtree, ClipboardList, HeartPulse, BadgePercent } from 'lucide-react';
import type { LeaveRequest } from '../../services/leaveRequestService';

export const typeIcons = {
  vacation: Palmtree,
  permission: ClipboardList,
  sickness: HeartPulse,
  rol: BadgePercent,
};

export const typeStyles = {
  vacation: {
    container: 'bg-orange-100 dark:bg-orange-900',
    icon: 'text-orange-600 dark:text-orange-400',
    labelKey: 'leave.type.vacation',
    defaultLabel: 'Vacation',
  },
  permission: {
    container: 'bg-blue-100 dark:bg-blue-900',
    icon: 'text-blue-600 dark:text-blue-400',
    labelKey: 'leave.type.permission',
    defaultLabel: 'Permission',
  },
  sickness: {
    container: 'bg-rose-100 dark:bg-rose-950',
    icon: 'text-rose-600 dark:text-rose-400',
    labelKey: 'leave.type.sickness',
    defaultLabel: 'Sickness',
  },
  rol: {
    container: 'bg-violet-100 dark:bg-violet-950',
    icon: 'text-violet-600 dark:text-violet-400',
    labelKey: 'leave.type.rol',
    defaultLabel: 'ROL',
  },
};

/** Calendar days covered by the request, both ends included. */
export const leaveDayCount = (request: Pick<LeaveRequest, 'startDate' | 'endDate'>): number => {
  const start = new Date(request.startDate);
  const end = new Date(request.endDate);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
};

/** Hours the request is worth, e.g. `"4h"`, assuming an 8h working day. */
export const leaveHoursDisplay = (
  request: Pick<LeaveRequest, 'startDate' | 'endDate' | 'durationType' | 'hours'>,
): string => {
  if (request.durationType === 'hours' && request.hours) {
    return `${request.hours}h`;
  }
  if (request.durationType === 'half_day_morning' || request.durationType === 'half_day_afternoon') {
    return `${leaveDayCount(request) * 4}h`;
  }
  return `${leaveDayCount(request) * 8}h`;
};
